import { render } from "./PageEquipment.vue?vue&type=template&id=5a285f33"
import script from "./PageEquipment.vue?vue&type=script&lang=js"
export * from "./PageEquipment.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__